import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoGridService {

  refreshGridSub$ : Subject<string> = new Subject<string>();
  refreshGrid$ : Observable<string> = this.refreshGridSub$.asObservable();

  constructor() { }

  refreshGrid(){
    this.refreshGridSub$.next('');
  }
}
